import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ApiResponse } from '@hutsix/ngxh6';

/**
 * An organisation applying to Tiwi Land Council for a Business Login.
 *
 * Public, and deliberately not a sign-up: submitting creates nothing anyone can use.
 * It records a pending business for TLC to decide on, and the same acknowledgement
 * comes back whether or not a record was created - a public form that confirmed which
 * organisations already hold a login would answer a question nobody asked it.
 *
 * The form is defined server-side in App\Form\Business\BusinessLoginApplicationType,
 * like the permit forms, so wording and validation change in the Symfony type.
 */
@Component({
    selector: 'app-apply-business-login',
    templateUrl: './apply-business-login.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ApplyBusinessLoginComponent {
    public sent = false;

    constructor(private cdRef: ChangeDetectorRef) {}

    public onSubmitted(res: ApiResponse<{ received?: boolean }>): void {
        // Only switch to the confirmation on a real success; a validation error must
        // leave the form in place so sf-form can show its inline messages.
        if (res?.data?.received) {
            this.sent = true;
            this.cdRef.detectChanges();
        }
    }
}
